import React, { useEffect, useRef, useState } from 'react';
import './projects.css';
import styled, { css, keyframes } from 'styled-components';
import { data } from './data';
import useOnScreen from '../../Components/brand/useOnScreen';
const Project = ({ app }) => {
  const projectRef = useRef();
  const visible = useOnScreen(projectRef);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (typeof window !== 'undefined')
      window.addEventListener('resize', () => {
        setScreenWidth(window.innerWidth);
      });
    return () =>
      window.removeEventListener('resize', () => {
        setScreenWidth(window.innerWidth);
      });
  }, [screenWidth]);

  return (
    <Anime
      visible={visible}
      ref={projectRef}
      className="projects-projects__project"
      screenWidth={screenWidth}
    >
      <h3>{app.title}</h3>
      <p> {app.description}</p>
      <p id="projects-projects__project-p">
        Demo: <a href={app.demo}>{app.title}</a>
      </p>
      <p id="projects-projects__project-p">
        GitHub: <a href={app.source}>Source</a>
      </p>
      <img src={app.img} alt={app.title} />
      <div className="projects-projects__project-iconsContainer">
        {app.icons
          ? app.icons.map((icon) => (
              <div
                className="projects-projects__project-icon"
                key={Math.random()}
              >
                {icon}
              </div>
            ))
          : ''}
      </div>
    </Anime>
  );
};

const Projects = () => {
  return (
    <div className="projects section__padding gradient__bg" id="projects">
      <h2 className="gradient__text">Projects</h2>
      <div className="projects-projects">
        {data.map((app) => (
          <Project key={app.title} app={app}></Project>
        ))}
      </div>
    </div>
  );
};

const animation = keyframes`


  from {
    transform:perspective(300px) translateZ(0);
  }

  to {
    transform:perspective(300px) translateZ(70px);
  }
      `;
const animation2 = keyframes`

  from {
    transform:perspective(300px) translateZ(70px);
  }

  to {
    transform:perspective(300px) translateZ(0);
  }
      `;
const Anime = styled.div`
  ${(props) =>
    props.visible && props.screenWidth > 769
      ? css`
          animation: ${animation} 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        `
      : css`
          animation: ${animation2} 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        `}
`;
export default Projects;
